// Autogenerated from `packages/@members/copy/models.generated/__model__.ts.hbs`

export const Collections = {
  Collections: 'collections',
  OtherInstructors: 'otherInstructors',
} as const;
